module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("f2RS2"))).then(() => module.bundle.root('1iHdE'));